import Tooltip from '@mui/material/Tooltip';

const CustomTooltip = ({ title, children, placement='left-start', ...props }) => {
  return (
    <Tooltip 
      title={title} 
      placement={placement} 
      slotProps={{ 
        tooltip: { 
          sx: { 
            fontFamily: "Unilever Shilling", 
            fontSize: '10px',
            backgroundColor: '#616161 !important',
            color: '#fff !important',
          } 
        } 
      }} 
      {...props}
    >
      {/* Wrap children in a span if there are multiple children */}
      <span>{children}</span>
    </Tooltip>
  );
};

export default CustomTooltip;